import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { FormFieldsEdit, FormFieldsView } from '../../../../types/form-types'
import { ActivityType } from '../../../services/constants'
import ReadOnlyLookupField from '../../wells/readonly-lookup-field'

interface WellDetailsInstallationConsentViewProps {
  isLoading: boolean
  fields: Partial<FormFieldsView> | Partial<FormFieldsEdit>
  isNewRecord?: boolean
}

export default function WellDetailsInstallationConsentView({
  isLoading,
  fields,
  isNewRecord,
}: WellDetailsInstallationConsentViewProps) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Well installation consent
      </Heading>
      <FormField isSkeleton={isLoading} labelId='activityType' label='Activity type'>
        {isNewRecord ? (
          <ReadOnlyLookupField
            isSkeleton={isLoading}
            labelledBy='activityType'
            value={`${fields.activityType ?? ''}`}
            fieldId='activityType'
          />
        ) : (
          <ReadOnlyField isSkeleton={isLoading} labelledBy='activityType' value={`${fields.activityType ?? ''}`} />
        )}
      </FormField>
      {fields.activityType === ActivityType.CONSENTED && (
        <FormField
          toolTipMessage={TOOLTIP.boreConsentNo}
          isSkeleton={isLoading}
          labelId='wellConsentNo'
          label='Well consent/authorisation number'
        >
          <ReadOnlyField isSkeleton={isLoading} labelledBy='wellConsentNo' value={`${fields.boreConsentNo ?? ''}`} />
        </FormField>
      )}
    </>
  )
}
